import './header.css';

function Header() {
  return (
    <div id='home' className='container header-container'>
      <h3>
        <p>
          Hello
          <br />
          I<span>'</span>m
        </p>
        <span className='tanjinp'>
        Tanjin Hossain
        </span>
      </h3>
      <h2>Front-End Web Developer</h2>
    </div>
  );
}
export default Header;
